import { IraUser } from 'services/requests';
import { mapIndependentIraTypeKeyToValue } from 'screens/IndependentIra/IraIndependentIra.utils';
import { formatInputDate } from './convertDate';
import { mapCustodianTypeKeyToValue } from './custodianType';

export const mapIraUserFields = (data: IraUser) => ({
  ...data,
  custodianType: mapCustodianTypeKeyToValue(data.custodianType),
  profileType: mapIndependentIraTypeKeyToValue(data.profileType),
  nextBillingDate: data.nextBillingDate
    ? formatInputDate(new Date(data.nextBillingDate)).replace(/[^\d]/g, '')
    : undefined,
});
